<template>
  <div>

    <el-table class="table" size="mini" :data="tableData" :height="hh" border>
      <el-table-column prop="elderlyName" label="姓名" width="100"></el-table-column>
<!--      <el-table-column prop="inspectItem" width="150" label="体检项目"></el-table-column>-->
      <el-table-column prop="organizationName" width="150" label="体检机构"></el-table-column>
      <el-table-column prop="inspectTime" label="体检时间" min-width="100"></el-table-column>
      <el-table-column prop="details" label="备注"  width="200"></el-table-column>

<!--      <el-table-column width="300" label="体检图片">-->
<!--        <template slot-scope="scope">-->
<!--          <div v-if="scope.row.listEInspectRecordImg !=null ">-->
<!--            <el-popover placement="right" trigger="click" v-for="(item,index) in scope.row.listEInspectRecordImg" :key="index">-->
<!--              <img :src="imgUrl+item.imgPath" style="width: 500px"/>-->
<!--              <img slot="reference" :src="imgUrl+item.imgPath" style="width:60px">-->
<!--            </el-popover>-->
<!--          </div>-->
<!--        </template>-->
<!--      </el-table-column>-->

      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="page">
      <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
      <div style="float: left;">
        <el-pagination small
          background
          layout="prev, pager, next"
          :total="totalItems"
          :page-size="pageSize"
          :current-page.sync="currentPage"  @current-change="current_change"></el-pagination>
      </div>
      <div style="float: right">
        <el-button type="primary" size="mini" plain @click.native="toggleModalAdd">添加</el-button>
      </div>
      <div style="clear: both;"></div>
    </div>

    <ExaminationRecordsAdd ref="myExaminationRecordsAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd"
                           v-on:resultSuccess="resultSuccess"></ExaminationRecordsAdd>

  </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    import ExaminationRecordsAdd from "./ExaminationRecordsAdd";

    export default {
        name: "ExaminationRecords",
        data(){
            return{
                showModalAdd: false,

                tableData: [],
                totalItems: 0,
                pageSize: 20,
                currentPage: 1,

              userCode: "",
              elderlyCode: "",
              elderlyName:'',

              imgUrl: this.$imgUrl,

              hh:this.$store.state.tableHeight-170,

            }
        },
        created(){

        },
        components:{
            ExaminationRecordsAdd
        },
        watch: {
            //监听全局变量
          '$store.state.tableHeight' : function(val){
            this.hh = val - 170;
          },
            disabled(val){
              //this.th = this.$store.state.tableHeight-(val?50:100);
            }
        },
        methods:{
            init(userCode,elderlyCode,elderlyName) {

              this.elderlyCode=elderlyCode;
              this.userCode=userCode;
              this.elderlyName = elderlyName;
              this.getList();

            },

            toggleModalAdd: function () {
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myExaminationRecordsAdd.init(this.elderlyCode,this.elderlyName);
            },
            closeAdd: function () {
                this.showModalAdd = !this.showModalAdd;
            },

            current_change: function (currentPage) {
                this.currentPage = currentPage;
                this.getList();
            },

            resultSuccess(){
              this.currentPage = 1;
              this.getList();
            },

            getList() {
              this.$axios({
                  method: "post",
                  url: this.$shopUrl + "EInspectRecord/Page",
                  data: {
                  timeStr: timeStr,
                  sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                  staffCode: getStaffCode(),
                  elderlyCode: this.elderlyCode,
                  pageIndex: this.currentPage,
                  pageSize: this.pageSize,
                  },
              }).then((response) => {
                  //console.log(response);
                  if (response.data.error == 0) {
                      this.tableData = response.data.data.list;
                      this.totalItems = response.data.data.total;
                  } else if (response.data.error == 1) {
                      this.$message.error(response.data.message);
                  }
                  })
                  .catch(function (error) {
                  console.log(error);
                  });
            },

          handleDelete(index,row){

            this.$confirm('确认删除吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {

              this.$axios({
                method: 'post',
                url: this.$shopUrl + "EInspectRecord/Delete",
                data: {
                  timeStr: timeStr,
                  sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                  staffCode: getStaffCode(),
                  einspectRecordCode:row.einspectRecordCode,

                }
              }).then((response) => {
                //console.log(response);
                if (response.data.error == 0) {

                  this.getList();

                } else if (response.data.error == 1) {
                  this.$message({type: 'info', message: response.data.message});
                }
              }).catch(function (error) {
                console.log(error);
              });

            }).catch(e => e)

          },



        },

    }
</script>

<style scoped>

</style>
